import { render } from "./lecteurDiapo.vue?vue&type=template&id=25058156&scoped=true"
import script from "./lecteurDiapo.vue?vue&type=script&lang=js"
export * from "./lecteurDiapo.vue?vue&type=script&lang=js"

import "./lecteurDiapo.vue?vue&type=style&index=0&id=25058156&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25058156"]])

export default __exports__